import type { $Fetch } from "ofetch";

/**
 * URL base da API do Google TTS
 */

const controller = "/telao";

interface ServiceAccountKey {
  type: string;
  project_id: string;
  private_key_id: string;
  private_key: string;
  client_email: string;
  client_id: string;
  auth_uri: string;
  token_uri: string;
  auth_provider_x509_cert_url: string;
  client_x509_cert_url: string;
}

/**
 * Classe de gerenciamento de chamadas da API de Text-to-Speech
 * @class
 */
export default class TTSApi {
  private api;

  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * Recupera um tema customizado do telão
   * @returns O tema customizado
   */
  async recuperarTTS() {
    try {
      const resp = await this.api(`${controller}/Autenticacao_TTS`, {
        method: "GET",
      });
      return resp;
    } catch (error) {
      console.error("Erro ao recuperar a autenticacao:", error);
      throw error;
    }
  }
}
